import { createAsyncThunk } from "@reduxjs/toolkit";

import axiosChargebee from "../utils/chargebee";
import axiosHubspot from "../utils/hubspot";
import axiosTenant from "../utils/tenant";

import {
  notification
} from "../actions";

export const getCustomer = createAsyncThunk("getCustomer", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.get(`/v1/users/${payload}`);
    if (response.status === 200 && response.data) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const createDeal = createAsyncThunk("createDeal", async (payload, thunkAPI) => {
  try {
    let response = await axiosHubspot.post(`/v1/create-deal`, payload);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      thunkAPI.dispatch(notification({ title: `Deal created`, message: `The subscription has been created / updated with some errors`, type: `warning` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `Deal created`, message: `The subscription has been created / updated with some errors`, type: `warning` }));
    console.log("Error:", e)
  }
})

export const updateDeal = createAsyncThunk("updateDeal", async (payload, thunkAPI) => {
  try {
    let response = await axiosHubspot.patch(`/v1/update-deal`, payload);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      thunkAPI.dispatch(notification({ title: `Deal updated`, message: `The subscription has been created / updated with some errors`, type: `warning` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `Deal updated`, message: `The subscription has been created / updated with some errors`, type: `warning` }));
    console.log("Error:", e)
  }
})

export const createCustomerCard = createAsyncThunk("createCustomerCard", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.post(`/v1/users/${payload.customerId}/card`, payload.dataCard);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const updateBillingInfo = createAsyncThunk("updateBillingInfo", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.patch(`/v1/users/${payload.customerId}/billing`, {billing_address: payload.billingInfo});
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      thunkAPI.dispatch(notification({ title: `Billing information not updated`, message: `${response.data.message}`, type: `warning` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const createCustomerSubscription = createAsyncThunk("createCustomerSubscription", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.post(`/v1/users/${payload.customerId}/subscription`, { "subscription_items": payload.subscription });
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      thunkAPI.dispatch(notification({ title: `Subscription was not purchased`, message: `${response.data.message}`, type: `success` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})